/**
 * Printbox Integration
 */

// Variant Change — notify Printbox when customer selects a different variant
subscribe(PUB_SUB_EVENTS.variantChange, (event) => {

  const variant = event.data?.variant;
  if (!variant) return;

  document.dispatchEvent(
    new CustomEvent("pbx:variant:change", {
      detail: { variantId: variant.id },
    })
  );
});

// Cart Validation — trigger Printbox project validation on cart update and page load
subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
  window.dispatchEvent(new Event("pbx:validate-projects"));
});

// Validate on initial cart page load
if (document.querySelector(".cart__contents") || document.querySelector("cart-drawer")) {
  document.addEventListener("DOMContentLoaded", () => {
    window.dispatchEvent(new Event("pbx:validate-projects"));
  });
}